<template>
  <div>
    <div
      v-if='statsCountOfClients && statsCountOfClientsUSA && statsCountOfPartners && statsCountOfPartnersUSA && statsCountOfSilver && statsCountOfSilverUSA'>
      Количество клиентов: {{ statsCountOfClients }}
      <br />
      Количество клиентов, которые зарегистрировались в США: {{ statsCountOfClientsUSA }}
      <br />
      Количество клиентов, которые зарегистрировались в Мексике: {{ statsCountOfClientsMexico }}
      <br />
      Количество партнеров (статусы Partner, Beginner, Professional, Expert, Master, Temination, Termination): {{ statsCountOfPartners }}
      <br />
      Количество партнеров (статусы Partner, Beginner, Professional, Expert, Master) в США: {{ statsCountOfPartnersUSA }}
      <br />
      Количество партнеров (статусы Partner, Beginner, Professional, Expert, Master) в Мексике: {{ statsCountOfPartnersMexico }}
      <br />
      Сколько Silver зарегистрировалось: {{ statsCountOfSilver }}
      <br />
      Сколько Silver зарегистрировалось в США: {{ statsCountOfSilverUSA }}
      <br />
      Сколько Silver зарегистрировалось в Мексике: {{ statsCountOfSilverMexico }}
      <br /><br />
      <div v-on:click='downloadPartners' style='text-decoration: underline; cursor: pointer'>Скачать партнеров (Partner, Beginner, Professional, Expert, Master, Temination, Termination)</div>
      <br />
      <div v-on:click='downloadUSAClients' style='text-decoration: underline; cursor: pointer'>Скачать клиентов USA</div>
      <br />
      <div v-on:click='downloadUSAPartners' style='text-decoration: underline; cursor: pointer'>Скачать партнеров USA</div>
      <br />
      <div v-on:click='downloadMexicoClients' style='text-decoration: underline; cursor: pointer'>Скачать клиентов Мексики</div>
      <br />
      <div v-on:click='downloadMexicoPartners' style='text-decoration: underline; cursor: pointer'>Скачать партнеров Мексики</div>
      <v-progress-circular
        v-if='loading'
        :size='50'
        color='primary'
        indeterminate
      ></v-progress-circular>
    </div>
    <v-progress-circular
      v-else
      :size='50'
      color='primary'
      indeterminate
    ></v-progress-circular>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { getToken } from '@/vue-apollo'

export default {
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async downloadPartners() {
      await this.download('partners', '/UploadCountOfPartners')
    },
    async downloadUSAClients() {
      await this.download('clientsUSA', '/UploadClientsUSA')
    },
    async downloadUSAPartners() {
      await this.download('partnersUSA', '/UploadPartnersUSA')
    },
    async downloadMexicoClients() {
      await this.download('clientsMexico', '/UploadClientsMexico')
    },
    async downloadMexicoPartners() {
      await this.download('partnersMexico', '/UploadPartnersMexico')
    },
    async download(nameIn, linkIn) {
      this.loading = true
      const auth = getToken()
      try {
        const response = await axios.get(process.env.VUE_APP_GRAPHQL_HTTP + '/..' + linkIn, {
          headers: {
            Authorization: 'Bearer ' + auth,
          },
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        let today = new Date()
        const dd = String(today.getDate()).padStart(2, '0')
        const mm = String(today.getMonth() + 1).padStart(2, '0')
        const yyyy = today.getFullYear()
        today = yyyy + '-' + mm + '-' + dd
        const name = nameIn + '_' + today + '.csv'
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      } catch (e) {
      }
      this.loading = false
    },
  },
  apollo: {
    statsCountOfClients: {
      query: gql`query { statsCountOfClients:StatsCountOfClients }`,
    },
    statsCountOfClientsUSA: {
      query: gql`query { statsCountOfClientsUSA:StatsCountOfClientsUSA }`,
    },
    statsCountOfClientsMexico: {
      query: gql`query { statsCountOfClientsMexico:StatsCountOfClientsCountry(country: 14) }`,
    },
    statsCountOfPartners: {
      query: gql`query { statsCountOfPartners:StatsCountOfPartners }`,
    },
    statsCountOfPartnersUSA: {
      query: gql`query { statsCountOfPartnersUSA:StatsCountOfPartnersUSA }`,
    },
    statsCountOfPartnersMexico: {
      query: gql`query { statsCountOfPartnersMexico:StatsCountOfPartnersCountry(country: 14) }`,
    },
    statsCountOfSilver: {
      query: gql`query { statsCountOfSilver:StatsCountOfSilver }`,
    },
    statsCountOfSilverUSA: {
      query: gql`query { statsCountOfSilverUSA:StatsCountOfSilverUSA }`,
    },
    statsCountOfSilverMexico: {
      query: gql`query { statsCountOfSilverMexico:StatsCountOfSilverCountry(country: 14) }`,
    },
  },

}
</script>
